import { useStore } from "vuex"
import GetLabel from "foundation/js/getLabel"
import ActivityCard from "../ActivityCard/ActivityCard.vue"
import { onMounted, computed } from "vue"
import deepClone from "foundation/js/deepClone"


export default {
    name: "CalendarOverlay",
    components: {
        ActivityCard
    },
    props: {
        groupId: {
            type: String,
            required: true
        },
        skip: {
            type: Number,
            required: true,
            default: 0
        },
        take: {
            type: Number,
            required: true,
            default: 10
        },
        createEventUrl: {
            type: String,
            required: true
        },
        allowedToEdit: {
            type: Boolean,
            required: true
        }
    },
    setup(props) {
        const store = useStore()
        
        const GUID = 'calendarEvents'
        const groupId = computed(() => store.state.main.page_overlay_content_data.groupId)
        const skip = computed(() => store.state.main.page_overlay_content_data.skip)
        const take = computed(() => store.state.main.page_overlay_content_data.take)
        const createEventUrl = computed(() => store.state.main.page_overlay_content_data.createEventUrl)
        const allowedToEdit = computed(() => store.state.main.page_overlay_content_data.allowedToEdit)

        const url = process.env.FRIVILLIGE_GROUP_EVENTS
            .replace('[pageId]', store.state.main.page_id)
            .replace('[groupId]', groupId.value)

        const activities = computed(() => {
            return deepClone(store.state.search.results[GUID] ?? [])
        })
        
        onMounted(() => {
            store.commit('search/set_replaceQueryInUrl', false)

            store.dispatch('search/initSearchScope', {
                guid: GUID,
                firstPageSize: take.value,
                showMorePageSize: take.value,
                url: url
            })

            store.dispatch('search/performSearch', {
                guid: GUID,
                    query: '',
                skip: skip.value,
                take: take.value
            })
        })

        const deleteEvent = (e, eventId) => {
            store.commit('main/set_page_overlay_content_data', {
                callback: () => {
                    store.dispatch('frivillige/deleteEvent', { 
                        pageId: store.state.main.page_id,
                        eventId: eventId
                    })
                    store.dispatch('main/closePageOverlay')
                }
            })

            store.dispatch("main/openPageOverlay", {
                overlayContent: "DeletePostOverlay",
                returnTarget: e.currentTarget,
            });
        }

        return {
            activities,
            allowedToEdit,
            createEventUrl,
            deleteEvent,
            getLabel: (labelKey) => GetLabel({ labelKey, labelCollection: 'CalendarOverlay' })
        }
    }
}